module.exports = __webpack_public_path__ + "static/media/S2CS-B.1d8254a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S2CS-B.jpg
// module id = 88
// module chunks = 0